(function () {
  'use strict';
  if (customElements.get('pms-suit-selector')) return;
  class PmsSuitSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#PmsSuitSeparates-"]');
        if (!link) return;
        const details = this.querySelector(link.getAttribute('href'));
        if (details) details.open = true;
      });
      this.querySelectorAll('[data-suit-card]').forEach(card => this.loadCard(card));
    }
    async loadCard(card) {
      const price = card.querySelector('[data-suit-price]');
      const config = JSON.parse(card.querySelector('[data-suit-config]').textContent);
      try {
        const products = await new window.PMSShopifyAdapter(card, config).loadProducts();
        const catalog = window.PMSBuilderCore.createCatalog(products, config.matchMode);
        const offer = window.PMSBuilderCore.getCompleteSuitOffer(catalog, config);
        if (!offer) { price.textContent = config.labels.unavailable; return; }
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: config.currency }).format(offer.min / 100);
        price.textContent = offer.min === offer.max ? money : `${config.labels.from} ${money}`;
        card.querySelectorAll('[data-suit-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('coat', offer.coat.id);
          url.searchParams.set('pant', offer.pant.id);
          link.href = url.href;
        });
        card.dataset.suitReady = 'true';
      } catch (error) {
        price.textContent = config.labels.error;
        console.error('[PMS suit cards]', error);
      }
    }
  }
  customElements.define('pms-suit-selector', PmsSuitSelector);
})();
